<template>
    <v-sheet class="d-flex flex-column fill-height" v-bind="{ style }" ref="body" @click="onClick">
        <v-card-text style="flex: 1 1 auto; overflow-x: auto; overflow-y: auto" class="scroll-primary pa-8 pa-sm-16 pa-md-32 grey lighten-5" ref="wrapper">
            <v-row justify="center" align="center" class="ma-n4 ma-sm-n8 ma-md-n16 flex-column">
                <template v-for="(page, pageIndex) in pages">
                    <v-col class="pa-4 pa-sm-8 pa-md-16" cols="auto" :key="pageIndex" :ref="`page-${pageIndex}`">
                        <body-item
                            v-model="items"
                            v-bind="{
                                mode,
                                page,
                                pageIndex,
                            }"
                            v-on="{
                                input: emit,
                                setIndex,
                            }"
                            class="employment-doc-body__page"
                        />
                    </v-col>
                </template>
            </v-row>
        </v-card-text>
        <body-tool
            v-model="items"
            v-bind="{ mode }"
            v-on="{
                input: emit,
            }"
        />
    </v-sheet>
</template>

<script>
import { initEmploymentField } from "@/assets/variables";
import { mapGetters, mapMutations, mapState } from "vuex";

import BodyItem from "./body/body-item.vue";
import BodyTool from "./body/body-tool.vue";

export default {
    components: {
        BodyItem,
        BodyTool,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField[]>} */
        value: { type: Array, default: () => [] },
        pages: { type: Array, default: () => [] },
        index: { type: Number, default: 0 },

        withoutReset: { type: Boolean, default: false },
        downloadName: { type: String, default: "document.pdf" },
    },
    data: () => ({
        items: [],
    }),
    computed: {
        ...mapState("employment/form/node", { isNodeOn: "isEdit" }),
        ...mapGetters("employment/form/tool", { isToolOn: "isOn" }),
        style() {
            let style = { position: "relative" };
            if (this.isToolOn) {
                style.cursor = "pointer";
            }
            return style;
        },
    },
    mounted() {
        this.init();
        this.sync();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onWindowResize);
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        ...mapMutations("employment/form/page", ["setSize"]),

        sync() {
            this.items = [...(this.value || [])].map(initEmploymentField);
        },

        emit() {
            this.$emit("input", this.items);
        },

        init() {
            if (!this.withoutReset) this.$store.dispatch("employment/form/reset");
            window.addEventListener("resize", this.onWindowResize);
            this.onWindowResize();
        },

        onClick() {
            if (this.isNodeOn) {
                this.$store.commit("employment/form/node/setIsEdit", false);
                this.$store.commit("employment/form/node/setActive", null);
            }
            if (this.isToolOn) {
                this.$store.commit("employment/form/tool/init");
                return;
            }
        },

        onWindowResize() {
            let intervalId = setInterval(() => {
                let body = this.$refs["body"];
                if (!body) return;
                let { width, height } = body.$el.getBoundingClientRect();
                this.setSize({ width, height });
                clearInterval(intervalId);
            }, 100);
        },

        scroll(index) {
            this.$refs[`page-${index}`][0].scrollIntoView();
        },

        setIndex(index) {
            this.$emit("setIndex", index);
        },
    },
};
</script>

<style></style>
